(function () {
  'use strict';

  var OPEN_CLASS     = 'nmm-open';
  var MOBILE_BP      = 990; 
  var HOVER_DELAY_MS = 120; 

  function isDesktop() {
    return window.innerWidth >= MOBILE_BP;
  }

  function updateHeaderHeight() {
    var header = document.querySelector('.section-custom-header');
    if (!header) return;
    var rect = header.getBoundingClientRect();
    document.documentElement.style.setProperty(
      '--nmm-header-height',
      rect.bottom + 'px'
    );
  }

  function repositionSubmenu(parentEl) {
    var submenu = parentEl.querySelector('[data-nmm-submenu]');
    if (!submenu || submenu.classList.contains('nmm-submenu--full')) return;

    var menuWidth = parseFloat(submenu.style.width) || submenu.offsetWidth;
    if (!menuWidth) return;

    var parentRect  = parentEl.getBoundingClientRect();
    var vw          = window.innerWidth;
    var padding     = 8;
    var idealLeft   = parentRect.left + parentRect.width / 2 - menuWidth / 2;
    var clampedLeft = Math.min(Math.max(idealLeft, padding), vw - menuWidth - padding);
    var offsetLeft  = submenu.offsetParent
      ? submenu.offsetParent.getBoundingClientRect().left
      : 0;

    submenu.style.left      = (clampedLeft - offsetLeft) + 'px';
    submenu.style.transform = 'none';
  }

  function closeAll(nav, except) {
    nav.querySelectorAll('[data-nmm-parent]').forEach(function (item) {
      if (item === except) return;
      closeItem(item);
    });
  }

  function openItem(parentEl) {
    parentEl.classList.add(OPEN_CLASS);
    setTriggerAria(parentEl, true);
    updateHeaderHeight();
    setTimeout(updateHeaderHeight, 50);
    repositionSubmenu(parentEl);
  }

  function closeItem(parentEl) {
    parentEl.classList.remove(OPEN_CLASS);
    setTriggerAria(parentEl, false);
  }

  function setTriggerAria(parentEl, isOpen) {
    var trigger = parentEl.querySelector('[data-nmm-trigger]');
    var submenu = parentEl.querySelector('[data-nmm-submenu]');
    if (trigger) trigger.setAttribute('aria-expanded', String(isOpen));
    if (submenu) submenu.setAttribute('aria-hidden',   String(!isOpen));
  }

  function openMobileNav(nav, btn) {
    nav.scrollTop = 0; // Resets scroll position to top when opened
    nav.classList.add('nmm-mobile-open');
    document.body.classList.add('nmm-scroll-lock');
    showOverlay(nav);
    if (btn) {
      btn.setAttribute('aria-expanded', 'true');
      toggleHamburgerIcons(btn, true);
    }
  }

  function closeMobileNav(nav) {
    nav.classList.remove('nmm-mobile-open');
    document.body.classList.remove('nmm-scroll-lock');
    hideOverlay(nav);
    document.querySelectorAll('[data-nmm-mobile-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
      toggleHamburgerIcons(btn, false);
    });
  }

  function toggleHamburgerIcons(btn, isOpen) {
    var iconOpen  = btn.querySelector('.nmm-icon-open');
    var iconClose = btn.querySelector('.nmm-icon-close');
    if (iconOpen)  iconOpen.style.display  = isOpen ? 'none' : '';
    if (iconClose) iconClose.style.display = isOpen ? ''     : 'none';
  }

  function showOverlay(nav) {
    var overlay = nav.querySelector('[data-nmm-overlay]');
    if (overlay) overlay.classList.add('nmm-overlay--visible');
  }

  function hideOverlay(nav) {
    var overlay = nav.querySelector('[data-nmm-overlay]');
    if (overlay) overlay.classList.remove('nmm-overlay--visible');
  }

  function initLevel2Panels() {
    document.querySelectorAll(
      '.nmm-col--link .nmm-col-heading[data-nmm-level2], .nmm-dropdown-child-trigger[data-nmm-level2]'
    ).forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        if (window.innerWidth >= MOBILE_BP) return;
        e.preventDefault();
        e.stopPropagation();
        var panelId = trigger.getAttribute('data-nmm-level2');
        var panel   = document.getElementById(panelId);
        if (panel) {
          panel.scrollTop = 0;
          panel.classList.add('nmm-level2-open');
        }
      });
    });

    document.querySelectorAll('[data-nmm-level2-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.closest('.nmm-level2-panel');
        if (panel) {
          panel.classList.remove('nmm-level2-open');
        }
      });
    });

    document.querySelectorAll('[data-nmm-level2-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.nmm-level2-panel').forEach(function (p) {
          p.classList.remove('nmm-level2-open');
        });
        var nav = document.querySelector('[data-nmm-nav]');
        if (nav) closeMobileNav(nav);
      });
    });
  }

  function initNav(nav) {
    nav.querySelectorAll('[data-nmm-parent]').forEach(function (parentEl) {
      var hoverTimer;

      parentEl.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        clearTimeout(hoverTimer);
        closeAll(nav, parentEl);
        openItem(parentEl);
      });

      parentEl.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        hoverTimer = setTimeout(function () {
          closeItem(parentEl);
        }, HOVER_DELAY_MS);
      });
    });

        nav.querySelectorAll('[data-nmm-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        var parentEl = trigger.closest('[data-nmm-parent]');
        if (!parentEl) return;

        var href = trigger.getAttribute('href');

        if (isDesktop()) {
          if (href && href !== '#') return;
        } else {
          // Mobile: tapping the text navigates to the link,
          // tapping anywhere else on the row opens the dropdown.
          var tappedText = e.target.closest('.nmm-link__text');
          if (tappedText && href && href !== '#') {
            return; // let the browser follow the link normally
          }
        }

        e.preventDefault();
        var isOpen = parentEl.classList.contains(OPEN_CLASS);
        closeAll(nav, parentEl);

        if (!isOpen) {
          openItem(parentEl);
        } else {
          closeItem(parentEl);
        }
      });
    });

    nav.querySelectorAll('[data-nmm-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var parentEl = btn.closest('[data-nmm-parent]');
        if (parentEl) {
          closeItem(parentEl);
        }
      });
    });

    nav.querySelectorAll('[data-nmm-close-panel]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeAll(nav, null);
        closeMobileNav(nav);
      });
    });

    nav.querySelectorAll('[data-nmm-close-main]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeAll(nav, null);
        closeMobileNav(nav);
      });
    });

    document.addEventListener('click', function (e) {
      if (!isDesktop()) return;
      if (!nav.contains(e.target)) closeAll(nav, null);
    });

    document.querySelectorAll('[data-nmm-mobile-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        nav.classList.contains('nmm-mobile-open')
          ? closeMobileNav(nav)
          : openMobileNav(nav, btn);
      });
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        updateHeaderHeight();
        closeAll(nav, null);
        closeMobileNav(nav);
      }, 200);
    });

    window.addEventListener('scroll', updateHeaderHeight, { passive: true });
  }

  function boot() {
    updateHeaderHeight();
    document.querySelectorAll('[data-nmm-nav]').forEach(initNav);
    initLevel2Panels();
    setTimeout(updateHeaderHeight, 50);
    setTimeout(updateHeaderHeight, 300);

    var header = document.querySelector('.section-custom-header');
    if (header) header.style.visibility = 'visible';

    initTransparentHeader();
    setTimeout(updateHeaderHeight, 100);
  }

  function initTransparentHeader() {
    var header = document.querySelector('[data-nmm-transparent]');
    if (!header) return;

    if (header.dataset.nmmTransparentHomepageOnly !== undefined) {
      var isHomepage = document.documentElement.dataset.nmmPageType === 'index';
      if (!isHomepage) {
        header.classList.remove('nmm-header--transparent');
        header.removeAttribute('data-nmm-transparent');
        return;
      }
    }

    var SCROLL_THRESHOLD = 10;

    function isTrDesktop() {
      return window.innerWidth >= MOBILE_BP;
    }

    function updateScrollState() {
      if (!isTrDesktop()) return;
      if (window.scrollY > SCROLL_THRESHOLD) {
        header.classList.add('nmm-header--scrolled');
      } else {
        header.classList.remove('nmm-header--scrolled');
      }
    }

    window.addEventListener('scroll', updateScrollState, { passive: true });

    header.addEventListener('mouseenter', function () {
      if (!isTrDesktop()) return;
      header.classList.add('nmm-header--hovered');
    });

    header.addEventListener('mouseleave', function () {
      if (!isTrDesktop()) return;
      header.classList.remove('nmm-header--hovered');
    });

    window.addEventListener('resize', function () {
      header.classList.remove('nmm-header--hovered');
      header.classList.remove('nmm-header--scrolled');
      updateScrollState();
    });

    updateScrollState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
}());

function initNmmToggleButtons() {
  document.querySelectorAll('[data-toggle-container]').forEach(function(container) {
    if (container._nmmToggleInit) return;
    container._nmmToggleInit = true;

    var row = container.closest('.nmm-row');
    if (!row) return;

    var inner = container.querySelector('.nmm-toggle-buttons-inner');
    if (!inner) return;

    var pill = document.createElement('div');
    pill.className = 'nmm-slider-pill';
    inner.appendChild(pill);

    var buttons = container.querySelectorAll('.nmm-toggle-btn');

    function getFilterItems() {
      return Array.from(row.querySelectorAll('[data-filter-id]')).filter(function(el) {
        var id = el.getAttribute('data-filter-id');
        return id && id !== '0' && !el.closest('[data-toggle-container]');
      });
    }

    function movePill(activeBtn) {
      var innerRect = inner.getBoundingClientRect();
      var btnRect   = activeBtn.getBoundingClientRect();
      pill.style.left  = (btnRect.left - innerRect.left) + 'px';
      pill.style.width = btnRect.width + 'px';
    }

    function applyFilter(filterId) {
      getFilterItems().forEach(function(item) {
        var ids = (item.getAttribute('data-filter-id') || '')
          .split(',').map(function(s) { return s.trim(); });
        item.style.display = ids.indexOf(filterId) !== -1 ? '' : 'none';
      });
    }

    getFilterItems().forEach(function(item) { item.style.display = 'none'; });

    if (buttons[0]) {
      buttons[0].classList.add('active');
      pill.style.transition = 'none';
      requestAnimationFrame(function() {
        movePill(buttons[0]);
        setTimeout(function() { pill.style.transition = ''; }, 50);
      });
      applyFilter(buttons[0].getAttribute('data-filter-id'));
    }

    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        buttons.forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        movePill(btn);
        applyFilter(btn.getAttribute('data-filter-id'));
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', initNmmToggleButtons);
document.addEventListener('nmm:open', initNmmToggleButtons);